import axios from '@/utils/http'

/**
 *获取企业列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getEnterpriseList (params) {
  return axios({
    url: '/AccountManageService/CompanyManage/GetCompanys',
    method: 'get', // default
    params: {
      ...params
    }
  })
}

/**
 *添加企业
 *
 * @export
 * @param {*} params
 * @returns
 */
export function addEnterprise (params) {
  return axios({
    url: '/AccountManageService/CompanyManage/AddCompany',
    method: 'post', // default
    data: {
      ...params
    }
  })
}

/**
 *修改企业
 *
 * @export
 * @param {*} params
 * @returns
 */
export function editEnterprise (params) {
  return axios({
    url: '/AccountManageService/CompanyManage/EditCompany',
    method: 'post', // default
    data: {
      ...params
    }
  })
}

/**
 *获取企业下拉列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getEnterpriseDropdownList (params) {
  return axios({
    url: '/AccountManageService/UserManage/GetCompanyDorpdownList',
    method: 'get', // default
    params: {
      ...params
    }
  })
}
